const VavatoTheme = {
  primary: '#A29060',
  secondary: '#6192A1',
  background: '#f6f6f6',
  text: '#595a5C',
  lightText: '#f6f6f6',
  darkText: '#343a40',
  warningText: '#df3a58',
  cardBackground: '#fff',
  darkBackground: '#c4c4c4',
  lightBackground: '#f8f9fa',
  tableHeaders: '#a8a8a8',
  success: '#259b11',
  error: '#B61e39',
  info: '#6092a2',
  navbarWidth: 330
}

export default VavatoTheme
